import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { BowMark } from './BowMark';
import { CheckoutButton } from './CheckoutButton';
import { CollectionMockup } from './CollectionMockup';
import { BRAND, PREVIEW_ANCHOR } from '../data/collection';
import { secondaryLinkClass } from '../utils/buttonStyles';
export function Hero() {
  return <section id="inicio" aria-labelledby="hero-title" className="w-full bg-ivory" data-id="element-71" data-mp="4njqyesgw3d3">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 pb-14 pt-6 sm:px-8 sm:pt-10 lg:grid-cols-[1.05fr_1fr] lg:gap-12 lg:pb-24 lg:pt-14" data-id="element-72" data-mp="12861s1aa6gsn">
        <div className="animate-hero-copy" data-id="element-73" data-mp="sb1bbp9ejz61">
          <p className="flex items-center gap-3" data-id="element-74" data-mp="s9zx5bx3awk3">
            <BowMark className="h-8 w-12 shrink-0" data-id="element-75" data-mp="nc85mj0cxcgf" />
            <span className="font-serif text-[1.65rem] font-semibold italic leading-none text-coral-ink sm:text-[2rem]" data-id="element-76" data-mp="nboov5mg0u3z">
              {BRAND.name}
            </span>
          </p>
          <p className="mt-2 text-[0.95rem] font-semibold text-sage-ink" data-id="element-77" data-mp="381e1dbzoc3ti">Moldes Multi-talle de ropa infantil</p>

          <h1 id="hero-title" className="mt-6 font-serif text-[2.4rem] font-semibold leading-[1.04] text-graphite text-balance sm:text-[3.2rem] lg:text-[3.65rem]" data-id="element-78" data-mp="3j9tymsm91cin">
            Cosé ropa infantil para vestir, regalar o vender.
          </h1>
          <p className="mt-5 max-w-xl text-[1.1rem] leading-relaxed text-graphite-soft text-pretty sm:text-[1.22rem]" data-id="element-79" data-mp="3e8msexzr8le3">
            31 modelos en seis volúmenes, con manuales de confección y moldes Multi-talle para imprimir en A4.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-80" data-mp="35aucpsq4fbq6">
            <CheckoutButton id="hero-cta" label="Quiero la colección completa" size="hero" data-id="element-81" data-mp="2qleq8oxmhsga" />
            <a href={PREVIEW_ANCHOR} className={secondaryLinkClass} data-id="element-82" data-mp="2vjpvemcz3es6">
              Ver un modelo por dentro
              <ArrowDownIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-y-0.5" aria-hidden data-id="element-83" data-mp="2hjoux80me9d8" />
            </a>
          </div>

          <p className="mt-6 text-[0.95rem] font-semibold text-graphite-soft" data-id="element-84" data-mp="s44hnmgsjjhd">
            6 manuales + 6 PDF de moldes <span className="text-coral" aria-hidden data-id="element-85" data-mp="n9i4bdr5fgun">·</span>
            <span className="sr-only" data-id="element-86" data-mp="id02aln7dwm0">,</span> 10 talles por estatura
          </p>
        </div>

        <div className="animate-hero-media" data-id="element-87" data-mp="de6rj0zawjpj">
          <CollectionMockup priority data-id="element-88" data-mp="dbaqh3s5pewv" />
        </div>
      </div>
    </section>;
}